"use client";
import React from "react";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const IFrameLoader = ({ src, showImage }: { src: string, showImage: boolean }) => {
    const { hasMouseMoved } = useMouseMovement();

    return <>{hasMouseMoved ? 
        <iframe
            title="YouTube Video"
            className={`${showImage ? "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full items-center shadow-lg" : "w-full h-full items-center shadow-lg" }`}
            src={src}
            loading="lazy"
            allowFullScreen></iframe>
        
        : null}</>;
};

export default IFrameLoader;